// Breadcrumb.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const linkStyle = (pathname, currentPath) => ({
  color: pathname === currentPath ? '#1E53E8' : 'inherit',
  textDecoration: 'none',
  fontWeight: pathname === currentPath ? 'bold' : 'normal',
  fontFamily: 'Roboto Flex',
  fontSize: 18
});

function Breadcrumb() {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
      <Link  style={linkStyle(pathname, '/Selectplan')}>Select Plan</Link>
      <Link  style={linkStyle(pathname, '/addressdetails')}>Address Details</Link>
      <Link  style={linkStyle(pathname, '/payment')}>Payment</Link>
      <Link  style={linkStyle(pathname, '/confirmation')}>Confirmation</Link>
    </Breadcrumbs>
  );
}

export default Breadcrumb;
